// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__LXkcD","content":"error_content__egNHa","error_text":"error_error_text__J05uM","title":"error_title__A6q62"};